export default __webpack_public_path__ + "static/media/palette.d1b0fcd4.svg";